import type { ChecklistReservedViews } from 'types/checklist-v2/ChecklistCommon';

export const checklistReservedViews = {
  list: 'list',
  board: 'board',
  timeline: 'timeline',
  calendar: 'calendar',
} as const satisfies Record<ChecklistReservedViews, ChecklistReservedViews>;

export const newViewId = 'new-view';
